import React from 'react';
import { observer } from 'mobx-react';
import { WeaRangePicker,WeaDatePicker } from 'ecCom';

@observer
export default class RangePickerNew extends React.Component<any, any>{

    onChange = (v) => {
        const {onChange,fieldid, isChild} = this.props;
        onChange(fieldid,v,isChild);
    }

    render() {
        const{type} = this.props;
        if(type=='290'){
            return <WeaRangePicker ecId={`${this && this.props && this.props.ecId || ''}_WeaRangePicker@096530`} 
                {...this.props}
                onChange={this.onChange}
            ></WeaRangePicker>
        }else{
            return <WeaDatePicker ecId={`${this && this.props && this.props.ecId || ''}_WeaDatePicker@433j07`}
            {...this.props}
            onChange={this.onChange}
        ></WeaDatePicker>
        }
        
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/commonComs/RangePickerNew.tsx